<template>
    <div>
        <loading :show="loading"></loading>
        <!-- ↓↓↓ ADVERTISE HEADER ↓↓↓ --------------------------------------------------------------------------------------------------------------------------------------->
        <section class="advertise-header">
            <div class="header-title">
                <h1 class="title">
                    Thank you
                    <span class="text-green"
                        >for taking the time to register your business.</span
                    >
                </h1>
            </div>

            <div class="header-container">
                <div class="header-discount" style="margin-left: 10px">
                    <a
                        href="#"
                        @click="showModal('sendMessageModal' + 0, 'discount')"
                    >
                        <img src="/images/Discount@2x.png" alt="Star rate" />
                    </a>
                </div>
                <div class="header-message">
                    <p>Hi there</p>
                    <p>
                        The team of WhatsWhat, Irelands Most Proactive and
                        Credible Directory for Irish Businesses. Established
                        over 20 years with close to 100,000 Businesses
                        Registered.
                    </p>
                    <p>
                        Thank's you
                        <span class="text-green"
                            >for taking the time to register your
                            business.</span
                        >
                    </p>
                    <p>
                        <span class="text-green"
                            >However if you Click on the free button you </span
                        >DO NOT GET THAT QUALITY BACK LINK
                        <span class="text-green">to your website.</span>
                    </p>
                    <p>
                        Nor do you get any of the Features and Benefits to
                        <span class="text-green"
                            >give your business the visibility it
                            deserves.</span
                        >
                    </p>
                    <p>
                        UPGRADE NOW **** STAND OUT FROM THE CROWD **** BE ABOVE
                        ALL THE FREE LISTINGS IN THE SEARCH
                    </p>
                </div>
            </div>

            <div id="toggle-switch">
                <p>Monthly</p>
                <label class="switch">
                    <input
                        type="checkbox"
                        v-model="price_display_selector"
                        checked="checked"
                    />
                    <span class="slider round"></span>
                </label>
                <p>Yearly</p>
            </div>
        </section>
        <!-- ↑↑↑ ADVERTISE HEADER ↑↑↑ --------------------------------------------------------------------------------------------------------------------------------------->

        <!-- ↓↓↓ PRICEPLANS ↓↓↓ --------------------------------------------------------------------------------------------------------------------------------------------->
        <section class="advertise-priceplans-section">
            <div class="advertise-priceplans-container">
                <p id="priceplan-title">WhatsWhat.ie Packages</p>

                <!-- ↓↓↓ NAMES ↓↓↓ -->
                <div class="card" id="names-only">
                    <div class="card-header">
                        <img
                            class="card-icon"
                            src="/images/Basic@2x.png"
                            alt="Check Icon"
                        />
                        <div class="divider"></div>
                        <p class="priceplan-title">WhatsWhat.ie Packages</p>
                    </div>
                    <div class="card-body">
                        <template
                            v-for="(subscription_feature,
                            index) in subscription_features"
                        >
                            <div
                                v-if="index == 0"
                                class="body-row"
                                id="top-left-rounded"
                            >
                                <p>{{ subscription_feature.name }}</p>
                            </div>

                            <div
                                v-else-if="
                                    index == subscription_features.length - 1
                                "
                                class="body-row"
                                id="bottom-left-rounded"
                            >
                                <p>{{ subscription_feature.name }}</p>
                            </div>

                            <div v-else class="body-row">
                                <p>{{ subscription_feature.name }}</p>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- ↑↑↑ NAMES ↑↑↑ -->

                <!-- ↓↓↓ BASIC ↓↓↓ -->

                <template v-for="(price_plan, index) in price_plans">
                    <div
                        class="card"
                        :id="getSubscriptionTypeCardId(price_plan.shortname)"
                    >
                        <div class="card-header">
                            <img
                                class="card-icon"
                                src="/images/Basic@2x.png"
                                alt="Check Icon"
                            />
                            <div class="divider"></div>
                            <p class="priceplan-title">
                                {{
                                    getSubscriptionTypeTitle(
                                        price_plan.shortname
                                    )
                                }}
                            </p>
                        </div>
                        <div class="card-body">
                            <template
                                v-for="(subscription_feature,
                                index) in subscription_features"
                            >
                                <div class="body-row no-mobile">
                                    <template
                                        v-if="
                                            featureIsLinked(
                                                subscription_feature.id,
                                                price_plan.id
                                            )
                                        "
                                    >
                                        <div
                                            v-if="
                                                price_plan.shortname !=
                                                    'enterprise' &&
                                                    featureIsLinked(
                                                        subscription_feature.id,
                                                        price_plan.id
                                                    ) == 'YES'
                                            "
                                            class="check-svg"
                                        >
                                            <svg
                                                id="bold"
                                                enable-background="new 0 0 24 24"
                                                height="16"
                                                viewBox="0 0 24 24"
                                                width="16"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g>
                                                    <path
                                                        d="m9.707 19.121c-.187.188-.442.293-.707.293s-.52-.105-.707-.293l-5.646-5.647c-.586-.586-.586-1.536 0-2.121l.707-.707c.586-.586 1.535-.586 2.121 0l3.525 3.525 9.525-9.525c.586-.586 1.536-.586 2.121 0l.707.707c.586.586.586 1.536 0 2.121z"
                                                    />
                                                </g>
                                            </svg>
                                        </div>

                                        <p v-else>
                                            {{
                                                featureIsLinked(
                                                    subscription_feature.id,
                                                    price_plan.id
                                                )
                                            }}
                                        </p>
                                    </template>
                                </div>
                            </template>

                            <template
                                v-for="(subscription_feature,
                                index) in subscription_features"
                            >
                                <div
                                    v-if="
                                        (featureIsLinked(
                                            subscription_feature.id,
                                            price_plan.id
                                        ) ||
                                            price_plan.shortname ==
                                                'enterprise') &&
                                            !loading
                                    "
                                    class="body-row cell-text"
                                >
                                    {{ subscription_feature.name }}

                                    <svg
                                        v-if="
                                            featureIsLinked(
                                                subscription_feature.id,
                                                price_plan.id
                                            ) == 'YES'
                                        "
                                        id="bold"
                                        enable-background="new 0 0 24 24"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g>
                                            <path
                                                d="m9.707 19.121c-.187.188-.442.293-.707.293s-.52-.105-.707-.293l-5.646-5.647c-.586-.586-.586-1.536 0-2.121l.707-.707c.586-.586 1.535-.586 2.121 0l3.525 3.525 9.525-9.525c.586-.586 1.536-.586 2.121 0l.707.707c.586.586.586 1.536 0 2.121z"
                                            />
                                        </g>
                                    </svg>

                                    <p
                                        v-else-if="
                                            featureIsLinked(
                                                subscription_feature.id,
                                                price_plan.id
                                            ) != false
                                        "
                                    >
                                        {{
                                            featureIsLinked(
                                                subscription_feature.id,
                                                price_plan.id
                                            )
                                        }}
                                    </p>
                                </div>
                            </template>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'free'"
                            class="card-footer"
                        >
                            <p class="priceplan-title">FREE</p>
                            <p>
                                I HAVE ALREADY SIGNED UP, BUT I RECKON I WILL BE
                                BACK
                            </p>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'enterprise'"
                            class="card-footer"
                        >
                            <p class="amazing">
                                For a customized package please contact us!
                            </p>
                            <div class="signup-btn">
                                <a
                                    href="#"
                                    @click="
                                        showModal(
                                            'sendMessageModal' + 0,
                                            'enterprise'
                                        )
                                    "
                                    >CONTACT US</a
                                >
                            </div>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'elite'"
                            class="card-footer"
                        >
                            <p
                                class="priceplan-title"
                                v-if="price_display_selector"
                            >
                                €{{
                                    parseInt(price_plan.yearly_price)
                                }}
                                +VAT/YEAR
                            </p>
                            <p v-else class="priceplan-title">
                                €{{
                                    parseInt(price_plan.monthly_price)
                                }}
                                +VAT/MONTH
                            </p>

                            <p class="amazing">
                                A fantstic opportunity for your business to be
                                in front of other businesses!
                            </p>
                            <div class="signup-btn">
                                <a
                                    href="#"
                                    @click="selectPlan(price_plan)"
                                    class="signup-btn"
                                    >SIGN UP</a
                                >
                            </div>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'premium'"
                            class="card-footer"
                        >
                            <p
                                class="priceplan-title"
                                v-if="price_display_selector"
                            >
                                €{{
                                    parseInt(price_plan.yearly_price)
                                }}
                                +VAT/YEAR
                            </p>
                            <p v-else class="priceplan-title">
                                €{{
                                    parseInt(price_plan.monthly_price)
                                }}
                                +VAT/MONTH
                            </p>
                            <p class="amazing">
                                Amazing value and great support for my
                                business,please sign me up!
                            </p>
                            <div class="signup-btn">
                                <a href="#" @click="selectPlan(price_plan)"
                                    >SIGN UP</a
                                >
                            </div>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'pro'"
                            class="card-footer"
                        >
                            <p
                                class="priceplan-title"
                                v-if="price_display_selector"
                            >
                                €{{
                                    parseInt(price_plan.yearly_price)
                                }}
                                +VAT/YEAR
                            </p>
                            <p v-else class="priceplan-title">
                                €{{
                                    parseInt(price_plan.monthly_price)
                                }}
                                +VAT/MONTH
                            </p>
                            <p>This is amazing value, please sign me up!</p>
                            <div class="signup-btn">
                                <a href="#" @click="selectPlan(price_plan)"
                                    >SIGN UP</a
                                >
                            </div>
                        </div>

                        <div
                            v-if="price_plan.shortname == 'Basic SEO'"
                            class="card-footer"
                        >
                            <p
                                class="priceplan-title"
                                v-if="price_display_selector"
                            >
                                €{{
                                    parseInt(price_plan.yearly_price)
                                }}
                                +VAT/YEAR
                            </p>
                            <p v-else class="priceplan-title">
                                €{{
                                    parseInt(price_plan.monthly_price)
                                }}
                                +VAT/MONTH
                            </p>
                            <p>This is amazing value, please sign me up!</p>
                            <div class="signup-btn">
                                <a href="#" @click="selectPlan(price_plan)"
                                    >SIGN UP</a
                                >
                            </div>
                        </div>
                    </div>
                </template>
                <!-- ↑↑↑ BASIC ↑↑↑ -->

                <modal
                    name="quotaModal"
                    classes="whatswhat-modal subscription-categories-modal"
                    :min-height="400"
                    height="auto"
                    :shiftY="0.3"
                >
                    <div class="subscription-categories-wrapper">
                        <div
                            class="close-modal"
                            @click="closeModal('quotaModal')"
                        >
                            <i class="icon-cross"></i>
                        </div>
                        <h2>{{ selected_plan.name }} plan</h2>
                        <div v-if="selected_plan.shortname == 'free'">
                            <p>
                                By using Free listing, you are limited to only
                                one category listing
                            </p>
                            <p>
                                Please select below only one from your previous
                                selected categories
                            </p>
                            <p></p>
                        </div>

                        <div v-if="selected_plan.shortname == 'pro'">
                            <p>
                                By using Pro plan, you are limited to maximum 3
                                categories
                            </p>
                            <p>Please update your category selections below</p>
                            <p></p>
                        </div>

                        <hr />
                        <p class="align-right">
                            Max Selections: {{ selected_plan.max_categories }}
                        </p>
                        <p class="align-right">
                            Selected:
                            {{
                                business_categories.filter(x => x.selected)
                                    .length
                            }}
                        </p>

                        <div class="categories-wrapper">
                            <div v-for="cat in business_categories">
                                <div
                                    class="casete"
                                    @click="selectCategory(cat)"
                                    :class="{
                                        selected: cat.selected,
                                        'casete-pro':
                                            selected_plan.shortname == 'pro'
                                    }"
                                >
                                    <p>{{ cat.name }}</p>
                                </div>
                            </div>
                        </div>

                        <button
                            :disabled="
                                business_categories.filter(x => x.selected)
                                    .length == 0
                            "
                            class="button__payment"
                            :class="
                                'button__payment--' + selected_plan.shortname
                            "
                            @click="updateCategories()"
                        >
                            {{ selected_plan.btn_text }}
                        </button>
                    </div>
                </modal>
                <modal
                    name="changePlanInfoModal"
                    classes="whatswhat-modal"
                    :adaptive="true"
                    :min-height="400"
                    height="auto"
                    :shiftY="0.3"
                >
                    <div class="subscription-categories-wrapper">
                        <div
                            class="close-modal"
                            @click="closeModal('changePlanInfoModal')"
                        >
                            <i class="icon-cross"></i>
                        </div>
                        <div class="modal-header">
                            <h2>Change subscription plan</h2>
                        </div>

                        <div class="modal-content">
                            <p>
                                You are about to change your current
                                subscription,
                                <br />
                                <br />
                                <b
                                    >{{ current_plan.name }} -
                                    {{ currentPlanPrice() }}</b
                                >
                                ,
                                <br />
                                <br />
                                with
                                <br />
                                <br />
                                <b>
                                    {{ selected_plan.name }} - €{{
                                        selected_plan.price
                                    }}/{{ recurrence_text }}
                                    + VAT
                                </b>
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button
                                class="button__payment"
                                :class="'button__payment--' + index"
                                @click="changePlan()"
                            >
                                Change plan
                            </button>
                        </div>
                    </div>
                </modal>
                <modal
                    name="stripePaymentModal"
                    classes="whatswhat-modal stripe-payment-modal"
                    height="auto"
                    :scrollable="true"
                    :shiftY="0.3"
                >
                    <div class="payment-form-wrapper">
                        <div
                            class="close-modal"
                            @click="closeModal('stripePaymentModal')"
                        >
                            <i class="icon-cross"></i>
                        </div>
                        <h4>BILLING INFORMATION</h4>
                        <div class="stripe-payment-lines-wrapper">
                            <div class="stripe-payment-line">
                                <div class="line-desc">Name</div>
                                <div class="line-val">{{ business.name }}</div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">Business Email</div>
                                <div class="line-val">{{ business.email }}</div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">Address</div>
                                <div class="line-val">
                                    {{ business.address }}
                                </div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">City</div>
                                <div class="line-val">{{ city_name }}</div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">Subscription</div>
                                <div class="line-val">
                                    {{ selected_plan.name }}
                                </div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">Recurrence</div>
                                <div class="line-val">
                                    {{ recurrence ? "yearly" : "monthly" }}
                                </div>
                            </div>

                            <div class="stripe-payment-line">
                                <div class="line-desc">Price</div>
                                <div class="line-val">
                                    €{{ selected_plan.price }} + VAT
                                </div>
                            </div>
                        </div>
                        <h4>PAYMENT INFORMATION</h4>
                        <!-- Stripe Elements Placeholder -->
                        <div id="card-element" class="input__text"></div>

                        <button
                            id="card-button"
                            class="button__payment mg-tp-45"
                            :class="
                                'button__payment--' + selected_plan.shortname
                            "
                            @click="addPaymentMethod()"
                        >
                            Pay Subscription
                        </button>
                    </div>
                </modal>
                <modal
                    name="upgradeModal"
                    classes="whatswhat-modal upgrade-from-free-modal"
                    height="auto"
                    :scrollable="true"
                    :shiftY="0.3"
                >
                    <div class="subscription-categories-wrapper">
                        <div
                            class="close-modal"
                            @click="closeModal('upgradeModal')"
                        >
                            <i class="icon-cross"></i>
                        </div>
                        <div class="modal-header">
                            <h2></h2>
                        </div>

                        <div class="modal-content">
                            <p>Hi there,</p>
                            <br />
                            <br />
                            <p>
                                Welcome to the WhatsWhat.ie, Ireland’s Leading
                                online business platform & community.
                            </p>
                            <p>
                                Before you decide whether our Free Listing is
                                right for your business at this time, you might
                                like to consider upgrading to receive the
                                following benefits for your business:
                            </p>
                            <br />
                            <ul>
                                <li>
                                    <b>
                                        A Quality Back Link to your
                                        Website....great for SEO and RANKING,
                                    </b>
                                    this
                                    <b
                                        >helps your business to reach more
                                        customers</b
                                    >
                                    online and helps your business to
                                    <b>be found ahead of others.</b>
                                </li>
                                <li>
                                    <b>Your very own Company Page</b>
                                    displaying your Products and Services.
                                </li>
                                <li>
                                    <b
                                        >Your Uploaded logo and Banner are
                                        automatically visible</b
                                    >
                                    on WhatsWhat.ie which helps you to stand
                                    out.
                                </li>
                                <li>
                                    <b>
                                        Social and Networking opportunities to
                                        help your business grow
                                    </b>
                                    and
                                    <b>reach more customers</b>
                                </li>
                                <!--<li><b>You stand out from the crowd and get your business to the top ranking spots</b> within your category, on WhatsWhat.ie</li>-->
                            </ul>
                            <br />
                            <br />
                            <p>
                                <b>All this for</b>
                                a little more than
                                <b>€1 per week</b>
                            </p>
                            <br />
                            <br />
                            <!--<p>Or indeed, just give me a buzz on <u>086 411 66 88</u>.</p>-->
                            <!--<p>I can show you how to get the best out of <b>WhatsWhat.ie</b> to help your business grow.</p>-->
                        </div>
                        <div class="modal-footer">
                            <div>
                                <a
                                    href="#"
                                    @click="upgradeToProAction()"
                                    class="button__payment"
                                >
                                    Upgrade to PRO Business today
                                </a>
                            </div>

                            <div class="text-center">or</div>
                            <div>
                                <a
                                    href="#"
                                    @click="fetchCategories()"
                                    class="text-link"
                                >
                                    Continue with Free
                                </a>
                            </div>
                        </div>
                    </div>
                </modal>
            </div>
        </section>

        <div class="send-message-container">
            <loading :show="loading"></loading>

            <modal
                :name="'sendMessageModal' + 0"
                title="Drop us a line"
                classes="whatswhat-modal send-message-modal"
                :hide-footer="true"
                size="lg"
                :adaptive="true"
                height="auto"
                :shiftY="0.3"
            >
                <div
                    class="close-modal"
                    @click="closeModal('sendMessageModal' + 0)"
                >
                    <i class="icon-cross"></i>
                </div>
                <h2>Drop us a line</h2>
                <hr />
                <div class="detailedstep">
                    <input type="hidden" name="path" id="path" value="" />

                    <div class="detailedstep__input" style="margin-top: 30px">
                        <input
                            type="text"
                            class="input__text"
                            id="nameInput"
                            v-model="subject"
                            name="input_name"
                            placeholder="Subject"
                            required
                        />
                    </div>

                    <div class="detailedstep__input">
                        <input
                            type="text"
                            class="input__text"
                            id="nameInput"
                            v-model="name"
                            name="input_name"
                            placeholder="Your name"
                            required
                        />
                    </div>
                    <div class="detailedstep__input">
                        <input
                            type="text"
                            class="input__text"
                            id="phoneInput"
                            v-model="phone"
                            name="input_phone"
                            placeholder="Phone number"
                            required
                        />
                    </div>
                    <div class="detailedstep__input">
                        <input
                            type="email"
                            class="input__text"
                            id="exampleInputEmail1"
                            v-model="email"
                            aria-describedby="emailHelp"
                            name="input_email"
                            placeholder="Email address"
                            required
                        />
                    </div>
                    <div class="detailedstep__input">
                        <textarea
                            class="input__text"
                            id="messageInput"
                            rows="5"
                            name="input_message"
                            v-model="message"
                            placeholder="Message"
                            required
                        ></textarea>
                    </div>
                    <div class="form-group">
                        <vue-recaptcha
                            :sitekey="recaptcha"
                            @verify="recaptchaVerified()"
                        ></vue-recaptcha>
                    </div>

                    <button
                        type="submit"
                        :disabled="
                            !subject || !name || !phone || !email || !message
                        "
                        class="button button__payment mx-auto"
                        @click="sendEmail()"
                    >
                        Send
                    </button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import Loading from "../Loading.vue";
import VueRecaptcha from "vue-recaptcha";
export default {
    props: [
        "plans",
        "business",
        "categories",
        "number_of_employees",
        "referrer",
        "category_routes",
        "has_default_pm",
        "preferred",
        "stripe_key",
        "payment_intent_secret",
        "city_name",
        "county_name",
        "type",
        "current_plan",
        "stripe_subscription",
        "subscription_features",
        "recaptcha"
    ],
    components: {
        loading: Loading,
        VueRecaptcha
    },

    data() {
        return {
            recurrence: true,
            recurrence_text: "year",
            price_plans: [],
            business_categories: [],
            selected_plan: {},
            stripe: "",
            app_url: "",
            loading: false,
            cardElement: "",
            card_id: "",
            image: "",
            priceplan_title: "",
            price_plans_linked: [],
            price_display_selector: 0,

            recaptchaResponse: null,
            recaptchaError: false,
            subject: "",
            name: "",
            phone: "",
            email: "",
            message: ""
        };
    },
    methods: {
        fetchLinkedFeatures() {
            let s_features_ids = this.subscription_features.map(
                (elm, index) => {
                    return elm.id;
                }
            );

            let s_types_ids = this.price_plans.map((elm, index) => {
                return elm.id;
            });

            let URL = "/businesses/checkLinkedFeature";

            axios
                .post(URL, {
                    s_types_ids: s_types_ids,
                    s_features_ids: s_features_ids
                })
                .then(response => {
                    this.price_plans_linked =
                        response.data.features_linked_array;
                });
        },

        featureIsLinked(feature_id, price_plan_id) {
            let is_linked = false;

            this.price_plans_linked.map(elm => {
                if (
                    elm.type_id == price_plan_id &&
                    elm.feature_id == feature_id
                ) {
                    is_linked = elm.value == "YES" ? "YES" : elm.value;
                }
            });

            return is_linked;
        },

        getSubscriptionTypeCardId(shortname) {
            console.log(shortname);

            switch (shortname) {
                case "free":
                    return "basic";
                    break;

                case "pro":
                    return "pro";

                    break;

                case "premium":
                    return "premium";

                    break;

                case "elite":
                    return "elite";

                    break;

                case "enterprise":
                    return "enterprise";

                    break;
            }
        },

        getSubscriptionTypeImgPath(shortname) {
            switch (shortname) {
                case "free":
                    return "/images/Basic@2x.png";

                    break;

                case "pro":
                    return "/images/pro@2x.png";

                    break;

                case "premium":
                    return "/images/Premium@2x.png";

                    break;

                case "elite":
                    return "/images/Elite@2x.png";

                    break;

                case "enterprise":
                    return "/images/Enterprise@2x.png";

                    break;
            }
        },

        getSubscriptionTypeTitle(shortname) {
            switch (shortname) {
                case "free":
                    return "BASIC";

                    break;

                case "pro":
                    return "PRO";

                    break;

                case "premium":
                    return "PREMIUM";

                    break;

                case "elite":
                    return "ELITE";

                    break;

                case "enterprise":
                    return "ENTERPRISE";

                    break;
            }
        },

        closeModal(modal) {
            this.$modal.hide(modal);
        },
        upgradeToProAction() {
            this.price_plans.forEach(plan => {
                if (plan.shortname == "pro") {
                    this.selectPlan(plan);
                }
            });
        },
        advertiseUrl() {
            return APP_URL + "/advertise";
        },
        changeRecurrence() {
            this.recurrence_text = this.recurrence ? "year" : "month";
            this.price_plans.forEach(plan => {
                plan.price = this.recurrence
                    ? plan.yearly_price
                    : plan.monthly_price;
                this.getBtnText(plan);
            });
        },

        selectPlan(plan) {
            if (plan.btn_text == "Selected") return false;
            this.selected_plan = plan;
            if (plan.shortname == "free") {
                this.$modal.show("upgradeModal");
            } else {
                this.fetchCategories();
            }
        },
        fetchCategories() {
            let self = this;
            self.$modal.hide("upgradeModal");
            this.loading = true;
            axios
                .get(
                    APP_URL + "/businesses/" + this.business.id + "/categories"
                )
                .then(function(response) {
                    self.loading = false;
                    self.business_categories = [];
                    response.data.categories.forEach(cat => {
                        let c = { id: cat.id, name: cat.name, selected: false };
                        self.business_categories.push(c);
                    });
                    console.log("im here");
                    if (
                        self.selected_plan.max_categories > 0 &&
                        self.business_categories.length >
                            self.selected_plan.max_categories
                    ) {
                        self.$modal.show("quotaModal");
                    } else {
                        self.orderPlan();
                    }
                })
                .catch(function(error) {
                    self.loading = false;
                });
        },
        currentPlanPrice() {
            let self = this;
            if (this.current_plan.shortname == "free") {
                return "free";
            } else {
                let price = "";
                this.price_plans.forEach(plan => {
                    if (
                        plan.monthly_price_id ==
                        self.stripe_subscription.stripe_plan
                    ) {
                        price = "€" + plan.monthly_price + "/month + VAT";
                    } else if (
                        plan.yearly_price_id ==
                        self.stripe_subscription.stripe_plan
                    ) {
                        price = "€" + plan.yearly_price + "/year + VAT";
                    }
                });
                return price;
            }
        },
        selectCategory(cat) {
            if (!cat.selected) {
                if (
                    this.business_categories.filter(x => x.selected).length ==
                    this.selected_plan.max_categories
                ) {
                    //
                } else {
                    cat.selected = true;
                }
            } else {
                cat.selected = false;
            }
        },

        updateCategories() {
            const self = this;
            self.loading = true;
            axios
                .patch(this.category_routes[this.selected_plan.shortname], {
                    categories: self.business_categories
                        .filter(x => x.selected)
                        .map(c => c.id)
                })
                .then(function(response) {
                    self.loading = false;
                    console.log(response);
                    if (response.data.success) {
                        self.closeModal("quotaModal");
                        self.orderPlan();
                    }
                })
                .catch(function(error) {
                    self.loading = false;
                });
        },
        planMessage(plan) {
            if (plan.shortname == "free") {
                return "";
            } else if (plan.shortname == "pro") {
                return "THIS IS AMAZING VALUE, PLEASE SIGN ME UP!";
            } else if (plan.shortname == "enterprise") {
                return "FOR A CUSTOMISED PACKAGE PLEASE CONTACT US";
            } else {
                return "AMAZING VALUE AND GREAT SUPPORT FOR MY BUSINESS. PLEASE SIGN ME UP!";
            }
        },
        techParagraph(plan) {
            if (plan.shortname == "free") {
                return "";
            } else if (plan.shortname == "pro") {
                return "MOST POPULAR";
            } else if (plan.shortname == "enterprise") {
                return "Customisable";
            } else {
                return "RECOMMENDED";
            }
        },
        createCardElement() {
            self.loading = true;
            setTimeout(() => {
                this.stripe = Stripe(this.stripe_key);
                const elements = this.stripe.elements();
                this.cardElement = elements.create("card");
                this.cardElement.mount("#card-element");
            }, 2000);
            self.loading = false;
        },
        changePlan() {
            let self = this;
            self.loading = true;
            axios
                .get(
                    "/businesses/" +
                        this.business.id +
                        "/swap/" +
                        this.selected_plan.id +
                        "/" +
                        this.recurrence_text
                )
                .then(response => {
                    self.loading = false;
                    if (response.data.success) {
                        window.location.replace("/dashboard");
                    } else {
                        window.location.replace(
                            response.data.finish_payment_route
                        );
                    }
                });
        },
        orderPlan() {
            let self = this;
            if (self.selected_plan.shortname == "free") {
                window.location.replace(
                    APP_URL + "/businesses/" + this.business.id + "/choose-free"
                );
            } else {
                if (self.has_default_pm && self.type == "change") {
                    self.$modal.show("changePlanInfoModal");
                } else {
                    self.$modal.show("stripePaymentModal");
                    self.$nextTick(function() {
                        self.createCardElement();
                    });
                }
            }
        },
         addPaymentMethod() {
            this.loading = true;
            this.stripe
                .confirmCardSetup(this.payment_intent_secret, {
                    payment_method: {
                        card: this.cardElement,
                        billing_details: {
                            name: this.business_name
                        }
                    }
                })
                .then(
                    function(result) {
                        this.loading = false;
                        if (result.error) {
                            console.log(result.error.message);
                        } else {
                            console.log("success");
                            this.createSubscription(
                                result.setupIntent.payment_method
                            );
                            this.cardElement.clear();
                            this.name = "";
                        }
                    }.bind(this)
                );
        },
        createSubscription(method) {
            let self = this;
            self.loading = true;
            let url =
                "/businesses/" +
                this.business.id +
                "/billing/" +
                this.selected_plan.id +
                "/subscribe/" +
                this.recurrence_text;
            console.log(url);
            axios
                .post(url, {
                    payment_method: method
                })
                .then(
                    function(response) {
                        self.loading = false;
                        if (response.data.success) {
                            window.location.replace("/dashboard");
                        } else {
                            window.location.replace(
                                response.data.finish_payment_route
                            );
                        }
                    }.bind(this)
                );
        },
        getBtnText(plan) {
            if (this.type == "change") {
                if (this.stripe_subscription.name === "Basic Business") {
                    plan.btn_text = "Change plan";
                } else {
                    plan.btn_text = this.recurrence
                        ? this.stripe_subscription.stripe_plan ==
                          plan.yearly_price_id
                            ? "Selected"
                            : "Change plan"
                        : this.stripe_subscription.stripe_plan ==
                          plan.monthly_price_id
                        ? "Selected"
                        : "Change plan";
                }
            } else {
                plan.btn_text =
                    plan.shortname == "free" ? "Use free" : "Order now";
            }
        },

        closeModal(modal, reloadData = false) {
            this.$modal.hide(modal);
            this.$v.$reset();
        },

        showModal(id, subject) {
            this.subject =
                subject == "enterprise"
                    ? "New subscription request  - Enterprise"
                    : "New promo subscription request  - 50% off";

            this.$modal.show(id);
            // this.$v.$touch();
        },
        recaptchaVerified(response) {
            this.recaptchaResponse = response;
        },
        sendEmail() {
            this.loading = true;
            let self = this;
            let messageData = {
                input_subject: this.subject,
                input_name: this.name,
                input_phone: this.phone,
                input_email: this.email,
                input_message: this.message,
                path: this.business.slug,
                "g-recaptcha-response": this.recaptchaResponse
            };
            let postUrl = "/lets-talk-whatswhat";
            axios
                .post(postUrl, messageData)
                .then(response => {
                    self.loading = false;
                    if (
                        response.data.message &&
                        response.data.message === "Mail sent"
                    ) {
                        self.$toastr.s(
                            "Your message has been sent successfully",
                            "Message sent"
                        );
                        self.closeModal("sendMessageModal" + self.business.id);
                    } else {
                    }
                })
                .catch(function(error) {
                    self.recaptchaError = true;
                });
        }
    },

    mounted() {
        this.app_url = APP_URL;
        this.price_plans = JSON.parse(JSON.stringify(this.plans));
        this.stored_categories = JSON.parse(JSON.stringify(this.categories));
        if (!this.type) this.type = "subscribe";
        console.log(this.current_plan);
        this.stored_categories.forEach(cat => {
            let c = { id: cat.id, name: cat.name, selected: false };
            this.business_categories.push(c);
        });
        console.log(this.current_plan, this.type);
        this.price_plans.forEach(plan => {
            plan.price = this.recurrence
                ? plan.yearly_price
                : plan.monthly_price;
            this.getBtnText(plan);
        });

        this.fetchLinkedFeatures();

        console.log(this.subscription_features);
        console.log(this.recaptcha);

        this.app_url = APP_URL;
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.whatswhat-modal.send-message-modal {
    h2,
    i {
        color: #444;
    }
    .detailedstep {
        flex: 1 0 50%;
        justify-content: center;
        align-items: center !important;
        .detailedstep__input {
            width: 100%;
            margin-bottom: 0.5em !important;
            .input__text {
                font-size: 18px;
                padding: 12px 14px 12px;
            }
        }
    }
}
</style>
